export const colWidths = [
    50,
    100,
    100
];
